'use client';

import React from 'react';
import MainLayout from './components/layouts/MainLayout';
import Link from 'next/link';

export default function Error({
  _error,
  reset,
}: {
  _error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <MainLayout isFooterContentWhite={false} isFooterBackgroundWhite={false}>
      <div className="flex h-full flex-col items-center justify-center py-20">
        <div className="max-w-[800px] px-6 text-center">
          <h1 className="mb-6 font-['Spectral'] text-4xl font-semibold">
            Something went wrong
          </h1>
          <p className="mb-8 text-lg">
            We're sorry, but something went wrong on our end. Please try again
            later.
          </p>
          <div className="flex flex-col justify-center gap-4 sm:flex-row">
            <button
              onClick={reset}
              className="inline-block rounded-lg bg-linear-to-r from-[#FF5C00] to-[#FF9900] px-6 py-3 font-semibold text-white transition-opacity hover:opacity-90"
            >
              Try again
            </button>
            <Link
              href="/"
              className="inline-block rounded-lg border border-gray-300 bg-white px-6 py-3 font-semibold text-gray-700 transition-colors hover:bg-gray-50"
            >
              Return to Homepage
            </Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
